export default __webpack_public_path__ + "static/media/unidadecardiologicarc.f39e7837.jpeg";